import React from 'react';

export default class Projects extends React.Component{
  render(){
    return ( 
      <p>Projects</p>
    )
  }
}